import type { GivingInterval } from 'models';
import { Divider, Empty, Icon, InfinityLoading } from 'ui';
import { useGivingsInfiniteQuery } from '../../../../../../queries';
import { GiveNowOption } from '../../../../give-now-option';
import { GiveNowOptionsSkeleton } from './give-now-options-skeleton';

type P = {
  getPathToGivingDetail: (id: string) => string;
  hasOnlyOneOrganization: boolean;
  interval: GivingInterval;
  organizationId: string;
};

const GiveNowOptions = ({ getPathToGivingDetail, hasOnlyOneOrganization, interval, organizationId }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useGivingsInfiniteQuery({
    filter: { giveNow: true, interval, organizationId },
    pagination: { pageSize: 12 },
  });

  const allGivings = data?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  const title = hasOnlyOneOrganization ? 'No giving' : 'No giving for this organization';
  const subtitle = hasOnlyOneOrganization
    ? 'It looks like there is no giving available in Give now at the moment. Please check back later or contact your organization’s admin for more information.'
    : 'There is currently no giving available for this organization in Give Now.  Please check back later or contact your organization’s admin for more information.';

  return (
    <>
      {isLoading ? (
        <GiveNowOptionsSkeleton />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      allGivings?.length ? (
        <>
          {hasOnlyOneOrganization ? null : <Divider marginNone />}
          {allGivings.map((giving) => (
            <GiveNowOption
              getPathToGivingDetail={getPathToGivingDetail}
              giving={giving}
              interval={interval}
              key={giving.id}
            />
          ))}
          <InfinityLoading
            hasMoreData={hasNextPage}
            isLoading={isFetching}
            onEnter={fetchNextPage}
            spinnerSize="small"
          />
        </>
      ) : (
        <Empty
          description={{
            subtitle,
            title,
          }}
          image={<Icon icon="hand-heart-line" />}
        />
      )}
    </>
  );
};

export default GiveNowOptions;
